module.exports = __webpack_public_path__ + "static/img/lemon_th.f7e047e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mixology/cans/lemon_th.png
// module id = YugA
// module chunks = 0